function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.313 60.063V39.724c0-2.809 2.009-5.216 4.773-5.718l10.727-2.038h7.75l10.726 2.038a5.813 5.813 0 014.773 5.718v20.337h-38.75z",
  fill: "#D9D9DC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.379 56.529c10.087 0 18.263-8.177 18.263-18.263 0-1.991-.33-3.902-.919-5.697l-3.16-.6h-7.75l-10.728 2.038a5.813 5.813 0 00-4.773 5.718v14.38a18.16 18.16 0 009.067 2.424z",
  fill: "#D9D9DC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.531 45.531H3.875a1.937 1.937 0 01-1.938-1.937V30.03c0-1.07.868-1.937 1.938-1.937h25.188c1.07 0 1.937.867 1.937 1.937v13.563c0 1.07-.867 1.937-1.938 1.937H18.407",
  fill: "#A0A4A8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.085 28.094H3.875c-1.07 0-1.938.867-1.938 1.937v13.563c0 1.07.868 1.937 1.938 1.937h13.84a26.177 26.177 0 008.37-17.437z",
  fill: "#A0A4A8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M50.375 45.531V33.073l3.875.736v11.722h-3.875z",
  fill: "#1ECD96",
  fillOpacity: 0.4
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.813 28.094V31a3.875 3.875 0 007.75 0v-2.906",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M31.969 14.531v5.813a8.718 8.718 0 008.718 8.718 8.718 8.718 0 008.72-8.718V14.53l-1.938-3.875-1.55 1.163a8.723 8.723 0 01-10.463 0l-1.55-1.163-1.937 3.875z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.756 4.96l1.678-1.262a8.807 8.807 0 018.929-.969l2.703 1.231a6.86 6.86 0 013.454 8.956L49.406 15.5v-.969l-1.938-3.875-1.55 1.163a8.722 8.722 0 01-10.462 0l-1.55-1.163-1.938 3.875v.969l-1.662-3.326a5.064 5.064 0 013.45-7.214zM31.969 15.5H31a1.937 1.937 0 100 3.875h.969M49.406 15.5h.969a1.937 1.937 0 110 3.875h-.969",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.125 54.25v-8.719H54.25v8.719",
  fill: "#1ECD96",
  fillOpacity: 0.4
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.938 54.25H54.25v5.813H1.937V54.25z",
  fill: "#D9D9DC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1.938 54.25H54.25v2.906H1.937V54.25z",
  fill: "#A8B0BC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M14.531 54.25V36.812h3.875V54.25",
  fill: "#D5CEC2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.125 45.531v8.719h12.082a18.325 18.325 0 007.925-8.719H27.125z",
  fill: "#1ECD96"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M14.531 48.053a26.325 26.325 0 003.875-3.18v-8.06h-3.875v11.24z",
  fill: "#E7E4DD"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M61.03 39.726c0-3.28-2.341-6.086-5.56-6.67l-9.957-1.892c.002-.055.016-.108.016-.163v-2.28c2.892-1.678 4.846-4.8 4.846-8.377a2.909 2.909 0 002.904-2.906 2.904 2.904 0 00-2.422-2.858l.553-1.28a7.844 7.844 0 00-.476-7.126 7.793 7.793 0 00-3.467-3.095l-2.703-1.232C41.57.394 37.657.82 34.852 2.923l-1.528 1.146.002.003a6.056 6.056 0 00-3.664 2.734 6 6 0 00-.223 5.802l.99 1.981a2.91 2.91 0 00-2.336 2.85 2.91 2.91 0 002.905 2.906H31c0 3.575 1.953 6.698 4.844 8.377V31c0 .056.014.108.016.163l-3.891.74V30.03a2.91 2.91 0 00-2.907-2.906H3.875a2.91 2.91 0 00-2.906 2.906v13.563A2.91 2.91 0 003.875 46.5h9.688v6.781H1.937a.968.968 0 00-.968.97v5.812c0 .535.433.968.969.968h58.124a.967.967 0 00.968-.968V39.726zM50.373 16.469a.97.97 0 01.001 1.937h-.001V16.47zm-19.375 1.937a.97.97 0 010-1.937v1.937zm.173-6.666a4.073 4.073 0 01.152-3.939 4.113 4.113 0 013.511-1.988c1.52 0 2.929.754 3.773 2.017l.303.457 1.613-1.075-.304-.456a6.45 6.45 0 00-3.654-2.639c2.194-1.359 5.037-1.58 7.396-.506l2.703 1.23a5.863 5.863 0 012.608 2.33 5.9 5.9 0 01.358 5.362l-.066.153-1.231-2.463a.965.965 0 00-.643-.51.99.99 0 00-.805.168l-1.55 1.163a7.794 7.794 0 01-4.65 1.55 7.795 7.795 0 01-4.65-1.55l-1.55-1.163a.968.968 0 00-1.447.342l-1.314 2.627-.553-1.11zm1.765 8.604v-5.585l1.315-2.632.622.467a9.747 9.747 0 005.813 1.937 9.743 9.743 0 005.812-1.937l.621-.466 1.317 2.632v5.584c0 4.273-3.477 7.75-7.75 7.75-4.275 0-7.75-3.477-7.75-7.75zm10.655 9.24V31a2.909 2.909 0 01-2.905 2.905A2.909 2.909 0 0137.78 31v-1.415a9.68 9.68 0 005.812 0zm-11.624 4.29l4.346-.826c.775 1.645 2.437 2.794 4.373 2.794 1.936 0 3.598-1.15 4.372-2.795l4.346.826v10.69H31.968V33.874zM3.875 44.562a.97.97 0 01-.969-.97v-13.56a.97.97 0 01.969-.97h25.186a.97.97 0 01.97.97v14.53H19.373v-7.75a.968.968 0 00-.969-.968h-3.874a.968.968 0 00-.969.969v7.75H3.876v-.001zm22.281 1.937v6.781H22.28V46.5h3.876zm-5.812 0v6.781h-.97V46.5h.97zm-2.908-8.718v15.5H15.5v-15.5h1.936zM53.28 59.093H2.906v-3.875H53.28v3.875zm0-5.812H28.094v-6.78H53.28v6.78zm-1.938-8.718v-10.32l1.938.368.001 9.952h-1.94zm3.876 14.53V45.532l-.001-10.543a4.835 4.835 0 013.875 4.739v19.367h-3.874z",
  fill: "#25282B"
});

var SvgCashier = function SvgCashier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cashier.b4b786e9.svg";
export { ForwardRef as ReactComponent };